// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__312WJ","legacyBtn":"MutateMid_legacyBtn__3u-e5"};